import { render, staticRenderFns } from "./view.vue?vue&type=template&id=2f9fe3d0&scoped=true&"
import script from "./view.vue?vue&type=script&lang=js&"
export * from "./view.vue?vue&type=script&lang=js&"
import style0 from "./view.vue?vue&type=style&index=0&id=2f9fe3d0&lang=scss&scoped=true&"
import style1 from "./view.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9fe3d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f9fe3d0')) {
      api.createRecord('2f9fe3d0', component.options)
    } else {
      api.reload('2f9fe3d0', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=2f9fe3d0&scoped=true&", function () {
      api.rerender('2f9fe3d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/view.vue"
export default component.exports